import { hasLocalStorageAccess } from '../pwa';
export function getSafeLsJSON(lsKey, defaultValue) {
    if (!hasLocalStorageAccess()) {
        return defaultValue;
    }
    try {
        var saved = localStorage.getItem(lsKey);
        return saved ? JSON.parse(saved) : defaultValue;
    }
    catch (e) {
        return defaultValue;
    }
}
